import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class NoKidHungry extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='NoKidHungry'>

			<div className='nkHeader'>
				<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/nkh_logo.svg' />
			</div>

			<div className='nkCopyRow'>
				<div className='nkCopyWrapper'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/nkh_copya.svg' />
				</div>
			</div>

			<div className='nkInvolved'>
				<div className='nkInvolvedWrapper'>
					<div className='nkInvolvedTitle'>Here is how you can get involved:</div>
					<div className='nkInvolvedItemWrapper'>
						<div className='nkInvolvedItem'>
							<div className='nkItemIcon'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/auction.svg' />
							</div>
							<div className='nkItemTitle'>Shop our <span className='itemEm'>online auction</span></div>
							<div className='nkItemCopy'><span className='itemEm'>100% of the proceeds</span> will benefit <span className='itemEm'>No Kid Hungry</span></div>
						</div>
						<div className='nkInvolvedItem'>
							<div className='nkItemIcon'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/register.svg' />
							</div>
							<div className='nkItemTitle'><span className='itemEm'>Donate</span> at the <span className='itemEm'>Register</span></div>
							<div className='nkItemCopy'>at a <span className='itemEm'>Diamonds Direct</span> location. Visit our location page to find the <span className='itemEm'>location nearest you.</span></div>
						</div>
						<div className='nkInvolvedItem' onClick={() => this.openNew('https://www.instagram.com/diamondsdirect/')} style={{cursor: 'pointer'}}>
							<div className='nkItemIcon'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/instagram.svg' />
							</div>
							<div className='nkItemTitle'><span className='itemEm'>Follow us</span> on <span className='itemEm'>Instagram</span></div>
							<div className='nkItemCopy'>for the most up to date information on events and partnerships in each of our markets that will raise funds and awareness for this great cause.</div>
						</div>
					</div>
				</div>
			</div>

			<div className='nkBody'>
				<div className='nkBodyTitle'>Silent Auction</div>
				<div className='noKidText'>Diamonds Direct, in association with the Diamonds Direct Foundation is hosting online silent auctions with all proceeds benefitting No Kid Hungry. With stunning diamond classics, perfect for any occasion and unique, one-of-a-kind pieces ideal for a night on the town, why not let your next gift give back to those hit hardest by the widespread effects of COVID-19?</div>
				<div className='lotWrapper'>
					<div className='lotTitle'>Current Assortment</div>
					<div className='itemsWrapper' style={{margin: '20px 0', fontSize: '24px'}}>
						Check back soon for our next auction assortment!
					</div>
					<div className='itemsWrapper' style={{display: 'none'}}>

						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905602')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/am_pendant.jpg' />
							</div>
							<div className='itemTitle'>This amethyst and diamond necklace makes the perfect gift.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905689')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/dia_loop.jpg' />
							</div>
							<div className='itemTitle'>Dazzling diamond hoops add the perfect touch of sparkle to any wardrobe.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905525')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/tanzanite_pendant.jpg' />
							</div>
							<div className='itemTitle'>It's all in the details of this exquisite tanzanite and diamond halo necklace.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905615')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/dia_cross.jpg' />
							</div>
							<div className='itemTitle'>A diamond cross pendant perfect for everyday wear.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905458')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/tennis.jpg' />
							</div>
							<div className='itemTitle'>A sparkling tennis bracelet flaunting 42 round brilliant cut diamonds.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905626')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/orange_sapphire.jpg' />
							</div>
							<div className='itemTitle'>A one-of-a-kind orange sapphire and diamond halo necklace.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905473')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/geo_diamond_earrings.jpg' />
							</div>
							<div className='itemTitle'>Make a statement with these geometric diamond earrings.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905502')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/diamond_halo.jpg' />
							</div>
							<div className='itemTitle'>A diamond halo necklace that sparkles from every angle.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905645')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/ruby_halo_earrings.jpg' />
							</div>
							<div className='itemTitle'>A stunning pair of ruby and diamond halo earrings that are perfect for any occasion.</div>
						</div>
						<div className='lotItem' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905487')}>
							<div className='lotImage'>
								<img src='https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/diamond_drop.jpg' />
							</div>
							<div className='itemTitle'>Showcasing stunning details, these diamond design drop earrings make the perfect gift.</div>
						</div>


						

					</div>
				</div>

				<div className='nkButtonWrapper' style={{display: 'none'}}>
					<div className='nkSeeAllButton' onClick={() => this.openNew('https://www.32auctions.com/organizations/63382/auctions/101807?r=1&t=all')}>View All Auction Items</div>
				</div>

				<div className='nkDisclaimer' style={{display: 'none'}}>Product in the online silent auction will be exchanged every two weeks until May 31st 2021. Select each jewelry piece to view its unique minimum starting bid.</div>


				<div className='nkTermo' style={{display: 'none'}}>

					<div className='nkTermoWrapper'>
						<div className='nkGoalText'>$100,000+</div>
						<div className='nkBarWrapper'>
							<div className='nkBarFill'></div>
							<div className='nkBubble'></div>
						</div>
						<div className='nkCurrentText'>+$48,000</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default NoKidHungry;

function mapStateToProps(state) {
  return {

  };
}

export const NoKidHungryContainer = connect(
  mapStateToProps,
  allActionCreators
)(NoKidHungry);


// WEBPACK FOOTER //
// ./src/components/views/promopages/nokidhungry/NoKidHungry.jsx